import React, { useState } from "react";
import { HiArrowLeft } from "react-icons/hi";
import { FaCheckCircle } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import peopleHero from "Assets/Images/peopleHero.png";
import CreatorModel from "components/CreatorModal";

const BecomeACreatorHome = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch<any>();

  const [creatorModel, setCreatorModel] = useState(false);

  const clickLogin = () => {
    setCreatorModel((current) => !current);
  };

  const perks = [
    "Get a verified artist profile",
    "Sell your songs directly to fans",
    "Earn streaming revenue",
    "Grow and connect with your audience",
  ];

  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-gradient-to-b from-[#0c0c0f] via-[#101015] to-black text-white">
      {/* ambient glows */}
      <div className="pointer-events-none absolute -top-40 right-0 h-[500px] w-[500px] rounded-full bg-[var(--red,#F50537)]/20 blur-[140px]" />
      <div className="pointer-events-none absolute bottom-0 left-0 h-80 w-80 rounded-full bg-[var(--red,#F50537)]/10 blur-[120px]" />

      {/* back button */}
      <button
        onClick={() => navigate(-1)}
        className="absolute left-6 top-6 z-20 flex h-10 w-10 items-center justify-center rounded-full bg-white text-black transition-transform hover:bg-white/90"
        aria-label="Go back"
      >
        <HiArrowLeft />
      </button>

      <div className="relative mx-auto flex min-h-screen max-w-6xl flex-col items-center gap-10 px-6 py-20 md:flex-row md:justify-between md:py-0">
        {/* text */}
        <div className="z-10 max-w-xl text-center md:text-left">
          <span className="inline-flex items-center gap-2 rounded-full border border-[var(--red,#F50537)]/40 bg-[var(--red,#F50537)]/10 px-4 py-1 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--red,#F50537)]">
            For Creators
          </span>

          <h1 className="mt-5 text-[56px] font-bold leading-[1.05] tracking-tight max-xl:text-[44px] max-md:text-[38px] max-sm:text-[32px]">
            Connect With Your <br className="max-sm:hidden" /> Fans on AYOZAT
          </h1>

          <p className="mt-5 text-base leading-relaxed text-white/60 max-sm:text-sm">
            Become a verified artist — sell your songs, earn streaming revenue,
            and build a real connection with your audience.
          </p>

          {/* perks */}
          <ul className="mt-7 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {perks.map((perk) => (
              <li
                key={perk}
                className="flex items-center gap-2.5 text-sm text-white/80 max-sm:justify-center md:justify-start"
              >
                <FaCheckCircle className="shrink-0 text-[var(--red,#F50537)]" />
                {perk}
              </li>
            ))}
          </ul>

          <button
            className="button-red mt-9 cursor-not-allowed rounded-full px-8 py-3 text-lg font-bold text-white opacity-90"
            disabled
          >
            Coming Soon
          </button>
        </div>

        {/* hero image */}
        <div className="relative z-10 w-full max-w-md md:max-w-lg">
          <div className="pointer-events-none absolute inset-0 rounded-full bg-[var(--red,#F50537)]/15 blur-3xl" />
          <img
            src={peopleHero}
            alt="Creators on AYOZAT"
            className="relative w-full object-contain drop-shadow-2xl max-md:opacity-90"
          />
        </div>
      </div>

      {creatorModel && <CreatorModel clickLogin={clickLogin} />}
    </div>
  );
};

export default BecomeACreatorHome;